import React from "react";
import { Box, Grid, Tab, Tabs, Typography }
  from "@mui/material";
import PropTypes from "prop-types";
import Appointments from "../components/my_care_journey/appointments";
import Todo from "../components/my_care_journey/todo";
import SplintsandEquipments from "../components/my_care_journey/splintsandequipments";
import Schoolevents from "../components/my_care_journey/schoolevents";
import Interventions from "../components/my_care_journey/interventions";
import { cardgrey, dashboardText, eventTabPanel, icon34, imageIcon, lightcolor, paddingbox, rcolor } from "../style2";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2, backgroundColor: lightcolor }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function MyCareJourney(props) {
  //const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={paddingbox} id={props.id}>
      <Grid container>
        <Grid item xs={10}>
          <Box display="flex" alignItems="center" sx={dashboardText}>
            <Box component="img" src="assets/medical-journey.png" sx={icon34}></Box>
            <Box mr={1} /> Care Journey
          </Box>
          <Box m={2} />
        </Grid>
        <Grid item xs={12}>

          <Grid container sx={cardgrey}>
            <Grid item xs={2}>
              <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                sx={{ borderRight: 1, borderColor: "divider" }}
                TabIndicatorProps={{ style: { backgroundColor: rcolor, fontWeight: "bold" } }}
              >
                <Tab
                  label="Appointments"
                  sx={{
                    backgroundColor: lightcolor,
                    textTransform: "capitalize",
                    fontWeight: value === 0 ? "bold" : "normal"
                  }}
                  icon={<img style={imageIcon} alt='' src="/appointment-icon.png" width="35px" />}
                />
                <Tab
                  label="To do"
                  sx={{
                    backgroundColor: lightcolor,
                    textTransform: "capitalize",
                    fontWeight: value === 1 ? "bold" : "normal", mt: 1
                  }}
                  icon={<img style={imageIcon} src="/todo-icon.png" alt='' width="35px" />}
                />
                <Tab
                  label="Splints & Equipment"
                  sx={{
                    backgroundColor: lightcolor,
                    textTransform: "capitalize",
                    fontWeight: value === 2 ? "bold" : "normal", mt: 1
                  }}
                  icon={<img style={imageIcon} src="/equipment-icon.png" alt='' width="35px" />}
                />
                <Tab
                  label="School Events"
                  sx={{
                    backgroundColor: lightcolor,
                    textTransform: "capitalize",
                    fontWeight: value === 3 ? "bold" : "normal", mt: 1
                  }}
                  icon={<img style={imageIcon} src="/schoolevents-icon.png" alt='' width="35px" />}
                />
                <Tab
                  label="Interventions"
                  sx={{
                    backgroundColor: lightcolor,
                    textTransform: "capitalize",
                    fontWeight: value === 4 ? "bold" : "normal", mt: 1
                  }}
                  icon={<img style={imageIcon} src="/intervensions-icon.png" alt='' width="35px" />}
                />
              </Tabs>
            </Grid>
            <Grid item xs={10} style={{ padding: "0px", margin: "0px" }}>
              <TabPanel value={value} index={0} sx={eventTabPanel}>
                <Appointments />
              </TabPanel>
              <TabPanel value={value} index={1} sx={eventTabPanel}>
                <Todo />
              </TabPanel>
              <TabPanel value={value} index={2} sx={eventTabPanel}>
                <SplintsandEquipments />
              </TabPanel>
              <TabPanel value={value} index={3} sx={eventTabPanel}>
                <Schoolevents />
              </TabPanel>
              <TabPanel value={value} index={4} sx={eventTabPanel}>
                <Interventions />
              </TabPanel>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
